import styled from '@emotion/styled'
import TabPanel from '@mui/lab/TabPanel'
import {
    Box,
    Card,
    Chip,
    Container,
    DialogContent,
    FormControl,
    Typography,
} from '@mui/material'
import theme from 'candidate/theme'
import { Link } from 'react-router-dom'
import { getPxAsRem } from 'shared/utils'

export const EmailLink = styled.a`
    font-family: 'Roboto';
    font-size: ${getPxAsRem(14)};
    color: ${({ theme }) => theme.palette.other.link};
    text-decoration: none;
    max-width: 10rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
`

export const baseStyle = {
    padding: getPxAsRem(64),
    margin: getPxAsRem(28),
    borderWidth: 2,
    borderRadius: 2,
    borderColor: theme.palette.grey[300],
    borderStyle: 'dashed',
    backgroundColor: theme.palette.background.default,
    outline: 'none',
    transition: 'border .24s ease-in-out',
}

export const Header = styled(Container)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${getPxAsRem(16)};
    background-color: ${({ theme }) => theme.palette.greyscale.white};
    padding: ${getPxAsRem(24, 0)};
`

export const DesktopHeader = styled(Container)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: ${getPxAsRem(16)};
    border-radius: 4px;
    margin: ${getPxAsRem(16, 24)};
    background-color: ${({ theme }) => theme.palette.greyscale.white};
`

export const TabsContainer = styled(Box)`
    background-color: ${({ theme }) => theme.palette.greyscale.white};
    width: 100%;

    .Mui-selected {
        color: ${({ theme }) => theme.palette.other.link};
    }
    .MuiTabs-indicator {
        background-color: ${({ theme }) => theme.palette.other.link};
    }
`

export const StyledTabPanel = styled(TabPanel)`
    background-color: ${({ theme }) => theme.palette.other.background};
`

export const EditHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const StyledDialogContent = styled(DialogContent)`
    padding: ${getPxAsRem(32)};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${getPxAsRem(24)};
    min-width: ${getPxAsRem(300)};
    min-height: ${getPxAsRem(300)};
`
export const StyledCard = styled(Card)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: getPxAsRem(16),
    maxHeight: getPxAsRem(500),
    overflow: 'auto',
}))

export const StyledTypography = styled(Typography)(({ theme }) => ({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    WebkitLineClamp: 3,
    textOverflow: 'ellipsis',
}))

export const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: getPxAsRem(8),
}))

export const DialogButtonContainer = styled(FormControl)`
    display: flex;
    gap: ${getPxAsRem(8)};
    flex-direction: row;
`

export const Subtitle = styled(Typography)`
    color: ${({ theme }) => theme.palette.other.secondary_light};
    font-weight: 600;
`

export const MobileFullScreenContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.greyscale.white,
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    width: '100%',
    minHeight: 'fit-content',
    height: '100vh',
    boxSizing: 'border-box',
}))

export const MobileInfoBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: getPxAsRem(20),
}))

export const MobileStyledChip = styled(Chip)(({ theme }) => ({
    padding: getPxAsRem(0, 8),
    marginTop: getPxAsRem(12),
}))

export const MobileSharedWithBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: getPxAsRem(12),
}))

export const ActionButtonsContainer = styled(Box)`
    position: absolute;
    top: 16px;
    right: 16px;
`

export const LabelTypography = styled(Typography)`
    color: rgba(0, 0, 0, 0.6);
`

export const ValueTypography = styled(Typography)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`
export const StyledLink = styled(Link)`
    text-decoration: none;
    color: ${({ theme }) => theme.palette.other.link};
    &:focus,
    &:hover,
    &:visited,
    &:link,
    &:active {
        text-decoration: none;
    }
`
